import { all } from 'redux-saga/effects';

import incluirEstatistica from './incluir/saga';

export default all([incluirEstatistica]);
